import { t } from 'i18next';

export const required = value => (value ? undefined : t('validator:required'));

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const maxLength15 = maxLength(15);

export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;

export const maxValue = max => value =>
  value && value > max ? `Must less than ${max}` : undefined;

export const minValue18 = minValue(18);
export const maxValue28Bits = maxValue(268435455); // 2 ** 28 - 1
export const maxValue45Bits = maxValue(4503599627370495); // 2 ** 45 - 1
